import React from "react";
import { Grid2 } from "@mui/material";
import styles from "./SignUpAddonStyle.module.scss";

function SignUpAddon(props) {
  const { icon } = props;
  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.addOnNameContainer}>
        <Grid2 className={styles.icon}>{icon}</Grid2>
        <Grid2 className={styles.label}>Addon's</Grid2>
      </Grid2>
      <hr className={styles.line} />
      <Grid2 className={styles.addonContainer}>
        <Grid2 className={styles.addonWaf}>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.label}>WAF</Grid2>
            <Grid2 className={styles.freeLabel}>Free</Grid2>
          </Grid2>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.addonText}>
              Protect your website from cyber threats with advanced security
              against DDoS attacks, SQL injections, and malware.
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 className={styles.addonStaging}>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.label}>Staging Environment</Grid2>
            <Grid2 className={styles.freeLabel}>10 Hr free trial</Grid2>
          </Grid2>
          <Grid2 className={styles.addonLabels}>
            <Grid2 className={styles.addonText}>
              Create a secure staging environment to test changes, refine new
              features, and resolve issues — all without disrupting your live
              site. This includes development, staging, and production-ready
              deployments
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default SignUpAddon;
